import React, { useContext, useEffect, useRef, useState } from "react";
import {
	AnimatePresence,
	motion,
	useScroll,
	useTransform,
} from "framer-motion";
import { FaChevronDown, FaChevronRight, FaChevronUp } from "react-icons/fa";
import {
	IoIosArrowDown,
	IoIosArrowUp,
	IoIosClose,
	IoIosMenu,
} from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import categories from "../../utils/categories.json";
import ProfileIcon from "../common/Header/ProfileIcon";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";

const AnimateNav = () => {
	const { scrollY } = useScroll();
	const [isOpen, setIsOpen] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isCoursesOpen, setIsCoursesOpen] = useState(false);
	const navigate = useNavigate();
	const dropdownRef = useRef(null);
	const toggleRef = useRef(null);
	const { user } = useContext(AuthContext);

	const location = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	const toggleMenuDropdown = () => {
		setIsMenuOpen((prev) => !prev);
	};

	const pageNavigate = (path) => {
		if (
			user ||
			path === "auth" ||
			path === "about" ||
			path === "contact" ||
			path === "help" ||
			path === "howitworks" ||
			path === ""
		) {
			navigate(`/${path}`);
		} else {
			toast.info("Login to access the content");
			navigate(`/auth`);
		}

		setIsMenuOpen(false);
	};

	const externalpageNavigate = (path) => {
		window.location.href = path;
	};

	return (
		<div className=" w-full mb-14">
			<div className="sticky top-0 justify-between items-center pt-8 px-10 text-sm font-medium h-fit hidden lg:flex z-9999">
				{/* left side */}
				<div className="w-2/5 flex justify-start items-center gap-8 ml-6 select-none">
					<button
						ref={toggleRef}
						className="flex items-center gap-2"
						onClick={() => pageNavigate("enroll")}
					>
						<span>Courses </span>
						<FaChevronRight />
					</button>
					<button onClick={() => pageNavigate("about")}>About</button>
					<button onClick={() => pageNavigate("contact")}>
						Contact
					</button>
				</div>

				<div
					onClick={() => pageNavigate("")}
					className="flex justify-center items-center text-xl font-semibold cursor-pointer"
				>
					<span>Academy-</span>
					<span className="text-gray-500">nest</span>
				</div>

				{/* right side */}
				<div className="w-2/5 flex justify-end items-center gap-8 mr-6">
					<button onClick={() => pageNavigate("help")}>Help</button>
					<button onClick={() => pageNavigate("howitworks")}>
						How it works
					</button>

					{user ? (
						<ProfileIcon />
					) : (
						<>
							<button onClick={() => pageNavigate("auth")}>
								Login
							</button>
							<button
								onClick={() => pageNavigate("auth")}
								className="bg-black text-white text-xs px-6 py-3 rounded-full"
							>
								Signup
							</button>
						</>
					)}
				</div>
			</div>

			<div className="sticky top-0 flex items-center justify-between pt-8 px-10 text-sm font-medium lg:hidden h-fit">
				<div
					onClick={() => pageNavigate("")}
					className="flex items-center justify-center flex-1 text-xl ml-5 font-semibold"
				>
					<span>Academy-</span>
					<span className="text-gray-500">nest</span>
				</div>

				<div className="text-2xl">
					<button
						onClick={toggleMenuDropdown}
						className="flex items-center justify-center hover:text-gray-700 transition-colors"
					>
						<IoIosMenu />
					</button>
				</div>
			</div>

			<AnimatePresence>
				{isMenuOpen && (
					<motion.div
						ref={dropdownRef}
						key="menuDropdown"
						initial={{ opacity: 0, height: 0 }}
						animate={{ opacity: 1, height: "100vh" }}
						exit={{ opacity: 0, height: 0 }}
						transition={{ duration: 0.3 }}
						className="fixed top-0 left-0 right-0 mx-auto w-full bg-white flex flex-col items-center space-y-4 p-6 z-50 overflow-y-auto no-scrollbar"
					>
						<div
							className="absolute top-6 right-6 text-3xl cursor-pointer hover:text-gray-600 transition"
							onClick={toggleMenuDropdown}
						>
							<IoIosClose />
						</div>

						<div className="py-16 flex flex-col space-y-6 w-full text-sm">
							<div
								className="px-5 py-3 bg-black text-white font-medium border border-gray-500 rounded-xl flex justify-between items-center cursor-pointer"
								onClick={() => pageNavigate("enroll")}
							>
								<button>Courses</button>
								<div className="text-lg">
									<FaChevronRight />
								</div>
							</div>

							<div
								className="px-5 py-3 font-medium border border-gray-500 rounded-xl"
								onClick={() => pageNavigate("about")}
							>
								<button>About</button>
							</div>

							<div
								className="px-5 py-3 font-medium border border-gray-500 rounded-xl"
								onClick={() => pageNavigate("contact")}
							>
								<button>Contact</button>
							</div>

							<div
								className="px-5 py-3 font-medium border border-gray-500 rounded-xl"
								onClick={() => pageNavigate("help")}
							>
								<button>Help</button>
							</div>

							<div
								className="px-5 py-3 font-medium border border-gray-500 rounded-xl"
								onClick={() => pageNavigate("howitworks")}
							>
								<button>How it works</button>
							</div>

							{user ? (
								<div className="flex gap-6 justify-center items-center py-10 bg-gray-50">
									<div className="flex flex-col items-center px-6 py-4">
										<ProfileIcon />
										<div className="text-gray-800 font-semibold text-sm mt-3">
											{user.fullName}
										</div>
									</div>
								</div>
							) : (
								<div className="flex gap-4 justify-center items-center py-10 font-medium">
									<div
										className="px-5 py-3 border border-gray-500 rounded-xl"
										onClick={() => pageNavigate("auth")}
									>
										<button>Login</button>
									</div>

									<div
										className="px-5 py-3 bg-black text-white rounded-xl"
										onClick={() => pageNavigate("auth")}
									>
										<button>Signup</button>
									</div>
								</div>
							)}
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default AnimateNav;
